/* eslint-disable lines-around-comment */
import { withStyles } from '@mui/styles';
import React, { Component } from 'react';
import { batch, connect } from 'react-redux';
import { isMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions';
import { IconDotsHorizontal } from '../../../base/icons/svg';
import { getLocalParticipant, getParticipantById } from '../../../base/participants/functions';
import Popover from '../../../base/popover/components/Popover.web';
import { setParticipantContextMenuOpen } from '../../../base/responsive-ui/actions';
import Button from '../../../base/ui/components/web/Button';
import ConnectionIndicatorContent from 
// @ts-ignore
'../../../connection-indicator/components/web/ConnectionIndicatorContent';
import { THUMBNAIL_TYPE } from '../../../filmstrip/constants';
import { renderConnectionStatus } from '../../actions.web';
import FakeParticipantContextMenu from './FakeParticipantContextMenu';
import ParticipantContextMenu from './ParticipantContextMenu';
// @ts-ignore
import { REMOTE_CONTROL_MENU_STATES } from './RemoteControlButton';
const styles = () => {
    return {
        triggerButton: {
            padding: '3px !important',
            borderRadius: '4px',
            '& svg': {
                width: '18px',
                height: '18px'
            }
        },
        contextMenu: {
            position: 'relative',
            marginTop: 0,
            right: 'auto',
            marginRight: '4px',
            marginBottom: '4px'
        }
    };
};
/**
 * React {@code Component} for displaying an icon associated with opening the
 * the {@code VideoMenu}.
 *
 * @augments {Component}
 */
class RemoteVideoMenuTriggerButton extends Component {
    /**
     * Initializes a new RemoteVideoMenuTriggerButton instance.
     *
     * @param {Object} props - The read-only React Component props with which
     * the new instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this._onPopoverClose = this._onPopoverClose.bind(this);
        this._onPopoverOpen = this._onPopoverOpen.bind(this);
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _disabled, _overflowDrawer, _showConnectionInfo, _participantDisplayName, buttonVisible, classes, participantID, popoverVisible } = this.props;
        let content;
        if (_showConnectionInfo) {
            content = React.createElement(ConnectionIndicatorContent, { participantId: participantID });
        }
        else if (!_disabled) {
            content = this._renderRemoteVideoMenu();
        }
        if (!content) {
            return null;
        }
        const username = _participantDisplayName;
        return (React.createElement(Popover, { content: content, id: 'remote-video-menu-trigger', onPopoverClose: this._onPopoverClose, onPopoverOpen: this._onPopoverOpen, overflowDrawer: _overflowDrawer, position: this.props._menuPosition, visible: popoverVisible }, buttonVisible && !_disabled && (!isMobileBrowser() && React.createElement(Button, { accessibilityLabel: this.props.t('dialog.remoteUserControls', { username }), className: classes.triggerButton, icon: IconDotsHorizontal, size: 'small' }))));
    }
    /**
     * Disable and hide toolbox while context menu is open.
     *
     * @returns {void}
     */
    _onPopoverOpen() {
        const { dispatch, showPopover } = this.props;
        showPopover();
        dispatch(setParticipantContextMenuOpen(true));
    }
    /**
     * Render normal context menu next time popover dialog opens.
     *
     * @returns {void}
     */
    _onPopoverClose() {
        const { dispatch, hidePopover } = this.props;
        hidePopover();
        batch(() => {
            dispatch(setParticipantContextMenuOpen(false));
            dispatch(renderConnectionStatus(false));
        });
    }
    /**
     * Creates a new {@code VideoMenu} with buttons for interacting with
     * the remote participant.
     *
     * @private
     * @returns {ReactElement}
     */
    _renderRemoteVideoMenu() {
        const { _localVideoOwner, _participant, _remoteControlState, classes } = this.props;
        const props = {
            className: classes.contextMenu,
            onSelect: this._onPopoverClose,
            participant: _participant,
            thumbnailMenu: true
        };
        if (_participant === null || _participant === void 0 ? void 0 : _participant.fakeParticipant) {
            return (React.createElement(FakeParticipantContextMenu, Object.assign({}, props, { localVideoOwner: _localVideoOwner })));
        }
        return (React.createElement(ParticipantContextMenu, Object.assign({}, props, { remoteControlState: _remoteControlState })));
    }
}
/**
 * Maps (parts of) the Redux state to the associated {@code RemoteVideoMenuTriggerButton}'s props.
 *
 * @param {Object} state - The Redux state.
 * @param {Object} ownProps - The own props of the component.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state, ownProps) {
    var _a, _b, _c;
    const { participantID, thumbnailType } = ownProps;
    let _remoteControlState = null;
    const localParticipantId = (_a = getLocalParticipant(state)) === null || _a === void 0 ? void 0 : _a.id;
    const participant = getParticipantById(state, participantID !== null && participantID !== void 0 ? participantID : '');
    const _participantDisplayName = participant === null || participant === void 0 ? void 0 : participant.name;
    const _isRemoteControlSessionActive = (_b = participant === null || participant === void 0 ? void 0 : participant.remoteControlSessionStatus) !== null && _b !== void 0 ? _b : false;
    const _supportsRemoteControl = (_c = participant === null || participant === void 0 ? void 0 : participant.supportsRemoteControl) !== null && _c !== void 0 ? _c : false;
    const { active, controller } = state['features/remote-control'];
    const { requestedParticipant, controlled } = controller;
    const activeParticipant = requestedParticipant || controlled;
    const { overflowDrawer } = state['features/toolbox'];
    const { showConnectionInfo } = state['features/base/connection'];
    const { remoteVideoMenu } = state['features/base/config'];
    const { ownerId } = state['features/shared-video'];
    if (_supportsRemoteControl
        && ((!active && !_isRemoteControlSessionActive) || activeParticipant === participantID)) {
        if (requestedParticipant === participantID) {
            _remoteControlState = REMOTE_CONTROL_MENU_STATES.REQUESTING;
        }
        else if (controlled) {
            _remoteControlState = REMOTE_CONTROL_MENU_STATES.STARTED;
        }
        else {
            _remoteControlState = REMOTE_CONTROL_MENU_STATES.NOT_STARTED;
        }
    }
    let _menuPosition;
    switch (thumbnailType) {
        case THUMBNAIL_TYPE.TILE:
            _menuPosition = 'left-start';
            break;
        case THUMBNAIL_TYPE.VERTICAL:
            _menuPosition = 'left-end';
            break;
        case THUMBNAIL_TYPE.HORIZONTAL:
            _menuPosition = 'top';
            break;
        default:
            _menuPosition = 'auto';
    }
    return {
        _disabled: Boolean(remoteVideoMenu === null || remoteVideoMenu === void 0 ? void 0 : remoteVideoMenu.disabled),
        _localVideoOwner: Boolean(ownerId === localParticipantId),
        _menuPosition,
        _overflowDrawer: overflowDrawer,
        _participant: participant !== null && participant !== void 0 ? participant : { id: '' },
        _participantDisplayName: _participantDisplayName !== null && _participantDisplayName !== void 0 ? _participantDisplayName : '',
        _remoteControlState,
        _showConnectionInfo: Boolean(showConnectionInfo)
    };
}
export default translate(connect(_mapStateToProps)(withStyles(styles)(RemoteVideoMenuTriggerButton)));
